import React from "react";
import ReactDOM from "react-dom/client";
import { configureIcons, configureGoogleMaps, configureBarcodeReader } from "@em/ui";
import zxingReaderWasmUrl from "zxing-wasm/reader/zxing_reader.wasm?url";
import { configureAppCache } from "@em/utils";

import { IconRegistry, FallbackIcon } from "@/components/generic/AppIcon/iconRegistry.generated";
import { appEnv } from "@/config/branding";
import App from "./App";

// Inject this app's generated icon set into @em/ui once, before anything renders —
// so AppIcon resolves in the app AND in shared @em/ui components on every route.
configureIcons(IconRegistry, FallbackIcon);

// Inject the Google Maps API key so @em/ui's GoogleMapsContext can load the SDK.
configureGoogleMaps({ apiKey: appEnv.googleMapsApiKey });

// Serve the barcode scanner's decoder (zxing-wasm) OURSELVES instead of from its public CDN. This only
// records the URL: the decoder is loaded the first time a scanner opens and the service worker caches it
// from then on (vite.config.ts → runtimeCaching), so the scan station keeps working with no signal.
configureBarcodeReader({ wasmUrl: zxingReaderWasmUrl });

// Inject the build version @em/utils' appCache stamps into entries (keeps the
// package free of Vite's import.meta.env).
configureAppCache({ getAppVersion: () => import.meta.env.VITE_APP_VERSION || "unknown" });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
